module.exports = __webpack_public_path__ + "img/p_cl.fa69fbfd.png";